<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th
            class="text-left"
            v-for="(item, index) in props.headers"
            :key="index"
          >
            {{ item.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in props.items" :key="index">
          <td v-for="(header, headerIndex) in props.headers" :key="headerIndex">
            {{ item[props.headers[headerIndex].field] }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: "TablaSimple",
  props: {
    props: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
};
</script>
